import { render, staticRenderFns } from "./chat2.vue?vue&type=template&id=5b25082e&scoped=true&"
import script from "./chat2.vue?vue&type=script&lang=js&"
export * from "./chat2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b25082e",
  null
  
)

export default component.exports